// 상단 네비게이션: 좌(로고+홈이름+섹션전환) / 중(현재 글 제목) / 우(알림, 설정, 로그아웃)
import { NotifyBell } from './NotifyBell';

type Section = 'blog' | 'manage' | 'requests';

interface Props {
  siteTitle: string;
  currentTitle: string;
  section: Section;
  onSectionChange: (s: Section) => void;
  onToggleSidebar: () => void;
  onOpenSettings: () => void;
  onLogout: () => void;
  onToast: (msg: string) => void;
}

export function Gnb({
  siteTitle,
  currentTitle,
  section,
  onSectionChange,
  onToggleSidebar,
  onOpenSettings,
  onLogout,
  onToast,
}: Props) {
  return (
    <header class="gnb">
      {section === 'blog' && (
        <button class="gnb__menu-btn" onClick={onToggleSidebar} aria-label="메뉴">
          ☰
        </button>
      )}
      <div class="gnb__left">
        <img class="gnb__logo" src="/logo.webp" alt="로고" />
        <span class="gnb__home">{siteTitle}</span>
        <nav class="gnb__nav">
          <button
            class={`gnb__nav-btn ${section === 'blog' ? 'active' : ''}`}
            onClick={() => onSectionChange('blog')}
          >
            블로그
          </button>
          <button
            class={`gnb__nav-btn ${section === 'manage' ? 'active' : ''}`}
            onClick={() => onSectionChange('manage')}
          >
            운영관리
          </button>
          <a
            class="gnb__nav-btn"
            href="https://churches.churchdonation.kr"
            target="_blank"
            rel="noopener noreferrer"
          >
            홍보관리
          </a>
          <button
            class={`gnb__nav-btn ${section === 'requests' ? 'active' : ''}`}
            onClick={() => onSectionChange('requests')}
          >
            신청·문의관리
          </button>
        </nav>
      </div>

      <div class="gnb__title">{section === 'blog' ? currentTitle : ''}</div>

      <div class="gnb__right">
        <NotifyBell onToast={onToast} />
        <button class="btn btn--icon" onClick={onOpenSettings} aria-label="설정" title="설정">
          ⚙️
        </button>
        <button class="btn" onClick={onLogout}>
          로그아웃
        </button>
      </div>
    </header>
  );
}
